export var useLogging = function useLogging(Reactotron) {
  var reactotron = {
    trackState: function trackState() {
      return null;
    }
  };

  if (Reactotron) {
    reactotron = Reactotron;
  }

  return {
    reactotron: reactotron,
    stateTracker: reactotron
  };
};